export const CURRENCY_SYMBOL = "NAD$";
export const APP_NAME = "1860bet";
export const APP_TIMEZONE = "Africa/Windhoek";
